"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.containsSuperscript = containsSuperscript;
exports.wordPiecesWithoutSuperscript = wordPiecesWithoutSuperscript;
exports.wordPiecesWithSuperscript = wordPiecesWithSuperscript;
var TabletRenderer_1 = __importDefault(require("./TabletRenderer"));
var tabletUtils_1 = require("./tabletUtils");
var superscriptRegex = /<sup>.*<\/sup>/;
function containsSuperscript(markedupUnit) {
    return !!markedupUnit.match(superscriptRegex);
}
function isMarkupChar(char) {
    return [
        '%',
        '{',
        '}',
        ':',
        ';',
        '‹',
        '›',
        '«',
        '»',
        '+',
        'x',
        '⸢',
        '⸣',
        '[',
        ']',
        '!',
        '?',
        '(',
        ')',
        '/',
        '\\',
    ].includes(char);
}
function italicize(word) {
    var reading = '';
    word.split('').forEach(function (char) {
        if (isMarkupChar(char)) {
            reading += char;
        }
        else {
            reading += "<em>".concat(char, "</em>");
        }
    });
    return reading;
}
function wordPiecesWithoutSuperscript(word) {
    return word.split(superscriptRegex);
}
function wordPiecesWithSuperscript(word) {
    return word.match(/<sup>.*<\/sup>/g) || [];
}
var TabletHtmlRenderer = (function (_super) {
    __extends(TabletHtmlRenderer, _super);
    function TabletHtmlRenderer(renderer, _a) {
        var _b = _a === void 0 ? {} : _a, showNullDiscourse = _b.showNullDiscourse, highlightDiscourses = _b.highlightDiscourses;
        var _this = _super.call(this, renderer.getEpigraphicUnits(), renderer.getLocale(), renderer.getRendererType()) || this;
        _this.renderer = null;
        _this.renderer = renderer;
        _this.showNullDiscourse = showNullDiscourse || false;
        _this.highlightDiscourses = highlightDiscourses || [];
        return _this;
    }
    TabletHtmlRenderer.prototype.markedUpEpigraphicReading = function (unit) {
        var baseReading = _super.prototype.markedUpEpigraphicReading.call(this, unit);
        if (unit.type === 'determinative') {
            baseReading = "<sup>".concat(baseReading, "</sup>");
        }
        if (unit.type === 'phonogram' && unit.reading !== '...') {
            if (containsSuperscript(baseReading)) {
                var basePieces = wordPiecesWithoutSuperscript(baseReading);
                var superscriptPieces_1 = wordPiecesWithSuperscript(baseReading);
                var newReading_1 = '';
                basePieces.forEach(function (piece, idx) {
                    var followingSuperscript = superscriptPieces_1[idx] || '';
                    newReading_1 = newReading_1 + italicize(piece) + followingSuperscript;
                });
                baseReading = newReading_1;
            }
            else {
                baseReading = italicize(baseReading);
            }
        }
        if (this.showNullDiscourse &&
            unit.discourseUuid === null &&
            unit.reading !== '|') {
            baseReading = "<mark style=\"background-color: #ffb3b3\">".concat(baseReading, "</mark>");
        }
        else if (this.highlightDiscourses.includes(unit.discourseUuid || '')) {
            baseReading = "<mark>".concat(baseReading, "</mark>");
        }
        return baseReading;
    };
    TabletHtmlRenderer.prototype.lineReading = function (lineNum) {
        if (this.renderer) {
            this.renderer['markedUpEpigraphicReading'] =
                this.markedUpEpigraphicReading;
            this.renderer['applySingleMarkup'] = this.applySingleMarkup;
            return (0, tabletUtils_1.localizeString)(this.renderer.lineReading.call(this, lineNum), this.locale);
        }
        throw new Error('Undefined renderer passed to render decorator');
    };
    TabletHtmlRenderer.prototype.applySingleMarkup = function (markup, reading) {
        var formattedReading = reading;
        switch (markup.type) {
            case 'isCollatedReading':
                formattedReading += '<sup>!!</sup>';
                break;
            case 'isEmendedReading':
                formattedReading += '<sup>!</sup>';
                break;
            case 'uncertain':
                formattedReading += '<sup>?</sup>';
                break;
            case 'phoneticComplement':
                formattedReading = "<sup>".concat(formattedReading, "</sup>");
                break;
            default:
                return _super.prototype.applySingleMarkup.call(this, markup, reading);
        }
        return formattedReading;
    };
    return TabletHtmlRenderer;
}(TabletRenderer_1.default));
exports.default = TabletHtmlRenderer;
//# sourceMappingURL=TabletHtmlRenderer.js.map